import { create } from 'zustand';
import { createDebouncedJSONStorage } from 'zustand-debounce';
import { persist } from 'zustand/middleware';
import { HomeStore } from '../types/home';
import indexedDbStorage from '../utils/indexeddb-zustand-store';

export const storageName = 'MOOD_home_store';

const useHomeStore = create<HomeStore>()(
  persist(
    (set) => ({
      loadingDataFromBSApi: false,
      setLoadingDataFromBSApi: (loading) =>
        set({ loadingDataFromBSApi: loading }),

      showNotifications: false,
      setShowNotifications: (show) => set({ showNotifications: show }),

      countryList: [],
      setCountryList: (countries) => set({ countryList: countries }),

      segmentsList: [],
      setSegmentsList: (segments) => set({ segmentsList: segments }),

      companySizeList: [],
      setCompanySizeList: (sizes) => set({ companySizeList: sizes }),

      timeStepInterval: '60',
      setTimeStepInterval: (val) => set({ timeStepInterval: val }),

      showPricingModal: false,
      setShowPricingModal: (show) => set({ showPricingModal: show }),

      showContactModal: false,
      setShowContactModal: (show) => set({ showContactModal: show }),

      showFeaturesModal: false,
      setShowFeaturesModal: (show) => set({ showFeaturesModal: show }),

      showGetStartedModal: false,
      setShowGetStartedModal: (show) => set({ showGetStartedModal: show }),

      showDownloadApiModal: false,
      setShowDownloadApiModal: (show) => set({ showDownloadApiModal: show }),

      showCart: false,
      setShowCart: (show) => set({ showCart: show }),

      showUserProfile: false,
      setShowUserProfile: (show) => set({ showUserProfile: show }),

      showSearch: false,
      setShowSearch: (show) => set({ showSearch: show }),

      showMaintenanceBanner: 'false',
      setShowMaintenanceBanner: (show) => set({ showMaintenanceBanner: show }),

      showAdvertisingBanner: 'false',
      setShowAdvertisingBanner: (show) => set({ showAdvertisingBanner: show }),

      advertisingBannerButtonText: '',
      setAdvertisingBannerButtonText: (text) =>
        set({ advertisingBannerButtonText: text }),

      showSubscriptionExpiredModal: { message: '', header: '', status: false },
      setShowSubscriptionExpiredModal: (modal) =>
        set({ showSubscriptionExpiredModal: modal }),

      showLogin: false,
      setShowLogin: (show) => set({ showLogin: show }),

      showAssociateToCompany: { status: false, fun: () => null },
      setShowAssociateToCompany: (associate) =>
        set({ showAssociateToCompany: associate }),

      showResultCollapse: false,
      setShowResultCollapse: (show) => set({ showResultCollapse: show }),

      dropdownSearchbarOpen: false,
      setDropdownSearchbarOpen: (show) => set({ dropdownSearchbarOpen: show }),

      showSpectraModal: false,
      setShowSpectraModal: (show) => set({ showSpectraModal: show }),

      overridePointData: false,
      setOverridePointData: (state) => set({ overridePointData: state }),

      isChangeDatasetWarningVisible: false,
      setIsChangeDatasetWarningVisible: (state) =>
        set({ isChangeDatasetWarningVisible: state }),

      temporaryDatasetName: '',
      setTemporaryDatasetName: (text) => set({ temporaryDatasetName: text }),

      priceParameterSelection: 'download',
      setPriceParameterSelection: (text) =>
        set({ priceParameterSelection: text }),

      priceSpectraSelection: 'download',
      setPriceSpectraSelection: (text) => set({ priceSpectraSelection: text }),
    }),
    {
      name: storageName,
      storage: createDebouncedJSONStorage(indexedDbStorage, {
        debounceTime: 500,
      }),
      partialize: (state) => ({
        priceParameterSelection: state.priceParameterSelection,
        priceSpectreSelection: state.priceSpectraSelection,
      }),
    }
  )
);

export const isStoreEmpty = (state: HomeStore): boolean => {
  return (
    state.priceParameterSelection === 'download' ||
    state.priceSpectraSelection === 'download'
  );
};

export default useHomeStore;
